import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';


@Component({
  selector: 'rfr-time-picker',
  templateUrl: './rfr-time-picker.component.html',
  styleUrls: ['./rfr-time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RfrTimePickerComponent),
      multi: true,
    },
  ],
})
export class RfrTimePickerComponent implements ControlValueAccessor {
  selectedDate: string | null = null; // Final value bound to ngModel
  tempSelectedDate: string | null = null; // Temporary value for modal
  isDatePickerOpen = false; // Modal state
  @Input() readonly = false;
  @Input() class = '';
  @Input() style = '';
  @Input() labelText = '';
  @Input() required = false;
  @Input() alignInputText: 'center' | 'left' | 'right' = 'left';
  @Input() size: 'normal' | 'large' = 'normal'; // Default value is 'normal'
  @Output() onDatePicked = new EventEmitter<string>();

  // ControlValueAccessor methods
  private onChange = (value: any) => {};
  private onTouched = () => {};

  writeValue(value: any): void {
    console.log(value);
    if (value)
    {
      // console.log(value);
      // this.selectedDate = value.replace('T', ' '); 
      if(!value.includes('T'))
      {
        this.tempSelectedDate = `2000-01-01T${value}`;
        this.selectedDate = value;
      }        
      else
      {
        this.selectedDate = value.split('T')[1];
        this.tempSelectedDate = `2000-01-01T${this.selectedDate}`;
      }
        

      console.log(this.selectedDate, this.tempSelectedDate);
    }
    else {
      this.tempSelectedDate = this.getLocalDateTime();
    }
  }

  getLocalDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Open the datetime picker modal
  openDateTimePicker() {
    if(this.selectedDate) {
      // if(!this.selectedDate.includes(' '))
      //   this.selectedDate = `2000-01-01 ${this.selectedDate}`;

      // this.tempSelectedDate = `2000-01-01T${this.selectedDate}`;
      // console.log(this.tempSelectedDate);
    }    
    this.isDatePickerOpen = true;
  }

  // Confirm the date selection
  confirmDate() {
    if (!this.tempSelectedDate) {
      return;
    }

    this.selectedDate = this.tempSelectedDate.replace('T', ' ');
    this.selectedDate = this.selectedDate.split(' ')[1];
    
    // if(this.selectedDate.startsWith('00:'))
    // {
    //   const slplitData = this.selectedDate.split(':');
    //   this.selectedDate = `24:${slplitData[1]}:${slplitData[2]}`;
    // }

    this.onChange(this.selectedDate);

    this.onDatePicked.emit(this.selectedDate); // Emit the new date value

    this.closeDateTimePicker();
  }

  // Cancel the date selection
  cancelDate() {
    this.tempSelectedDate = null;
    if(this.selectedDate?.includes(' '))
      this.selectedDate = this.selectedDate.split(' ')[1];

    this.closeDateTimePicker();
  }

  // Close the modal
  closeDateTimePicker() {
    this.isDatePickerOpen = false;
  }
}